import React, { useEffect } from 'react';
import './../styles/service-page.css';
import PavingImg from "./../../public/images/Paving.JPG";

const PatioCleaningPage = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    // Parallax effect for hero background
    // const handleScroll = () => {
    //   const scrolled = window.scrollY;
    //   const heroBackground = document.querySelector('.hero-section');
    //   if (heroBackground && scrolled < 600) {
    //     const yPos = -(scrolled * 0.5);
    //     heroBackground.style.backgroundPositionY = `${yPos}px`;
    //   }
    // };

    // window.addEventListener('scroll', handleScroll);

    // Add scroll animations matching homepage
    const observeElements = () => {
      const elements = document.querySelectorAll('.slide-in-up, .slide-in-left, .slide-in-right');
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      elements.forEach(element => {
        observer.observe(element);
      });

      // Stagger animations for service cards
      const cards = document.querySelectorAll('.service-card');
      cards.forEach((card, index) => {
        card.style.transitionDelay = `${index * 0.1}s`;
      });

      // Stagger process steps
      const steps = document.querySelectorAll('.process-step');
      steps.forEach((step, index) => {
        step.style.transitionDelay = `${index * 0.15}s`;
      });
    };

    setTimeout(observeElements, 100);

    // Cleanup
    // return () => {
    //   window.removeEventListener('scroll', handleScroll);
    // };
  }, []);

  return (
    <div className="service-page">
      {/* Hero Section with Background Image */}
      <section 
        className="hero-section"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('https://media.istockphoto.com/id/865816876/photo/close-up-of-pressure-washer-cleaning-decking.jpg?s=612x612&w=0&k=20&c=ToK1Bdx68iXCjYA-dMuuPPezzyY-hQNzyXJ-bia7yBo=')`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="header-content slide-in-up">
            <h1>Patio Cleaning</h1>
            <p className="header-subtitle">
              Professional patio cleaning service removes dirt, grime, algae & stains. Restore your outdoor space's beauty with our pressure washing expertise.
            </p>
          </div>
        </div>
      </section>

      {/* Service Overview */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content slide-in-left">
              <h2>Why Choose Our Patio Cleaning Service?</h2>
              <p>
                Your patio is the heart of your outdoor living space, where memories are made 
                with family and friends. Over time, moss, algae, weathering, and general dirt 
                can transform your beautiful patio into a slippery, unsightly surface that 
                detracts from your garden's appeal.
              </p>
              <p>
                Our professional patio cleaning service uses specialized equipment and 
                eco-friendly solutions to restore your patio to its former glory. We carefully 
                clean all types of patio surfaces including natural stone, concrete slabs, 
                block paving, sandstone, limestone, and Indian stone without causing damage.
              </p>
              <div className="key-benefits">
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Removes moss, algae, and lichen growth</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Restores original colour and texture</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Re-sanding of joints included</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">✓</span>
                  <span>Safe for plants and garden furniture</span>
                </div>
              </div>
            </div>
            <div className="overview-image slide-in-right">
              <img src={PavingImg} alt="Professional patio cleaning in progress" />
            </div>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="whats-included">
        <div className="container">
          <h2 className="section-title slide-in-up">What's Included in Our Patio Cleaning Service</h2>
          
          <div className="services-grid">
            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🌿</span>
              </div>
              <h3>Algae & Moss Removal</h3>
              <p>
                Complete elimination of slippery algae, moss, and lichen that can make your patio dangerous and unsightly.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🧽</span>
              </div>
              <h3>Deep Surface Cleaning</h3>
              <p>
                Thorough cleaning of concrete, stone, brick, and tile surfaces to restore their original appearance.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🌈</span>
              </div>
              <h3>Stain Treatment</h3>
              <p>
                Specialized treatments for rust, food stains, grease, and other common patio discoloration issues.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>🔧</span>
              </div>
              <h3>Joint & Crack Cleaning</h3>
              <p>
                Detailed cleaning of grout lines, expansion joints, and cracks where dirt and weeds typically accumulate.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>♻️</span>
              </div>
              <h3>Eco-Safe Products</h3>
              <p>
                All our cleaning products are environmentally friendly and safe for your family, 
                pets, and surrounding landscaping while still being tough on dirt and stains.
              </p>
            </div>

            <div className="service-card slide-in-up">
              <div className="service-icon">
                <span>✅</span>
              </div>
              <h3>Quality Guarantee</h3>
              <p>
                We stand behind our work with a complete satisfaction guarantee. If you're not 
                happy with the results, we'll return to address any concerns at no extra cost.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="our-process">
        <div className="container">
          <h2 className="section-title slide-in-up">Our Simple 4-Step Process</h2>
          
          <div className="process-steps">
            <div className="process-step slide-in-left">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Free Quote & Assessment</h3>
                <p>
                  Contact us for a free, no-obligation quote. We'll assess your driveway's 
                  condition and provide you with a detailed estimate of the work required.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Preparation & Setup</h3>
                <p>
                  We'll protect your property and surrounding areas, then apply pre-treatment 
                  solutions to problem areas and set up our professional cleaning equipment.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-left">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Professional Cleaning</h3>
                <p>
                  Using the correct pressure settings for your driveway material, we systematically 
                  clean every area, paying special attention to stained and heavily soiled sections.
                </p>
              </div>
            </div>

            <div className="process-step slide-in-right">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Final Inspection</h3>
                <p>
                  We conduct a thorough quality check to ensure all areas have been properly cleaned, 
                  and discuss optional protective treatments to maintain your patio's appearance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content slide-in-up">
            <h2>Ready to Restore Your Patio?</h2>
            <p>
              Get your free quote today and see how we can transform your patio's appearance. 
              Most quotes provided within 24 hours with no obligation to proceed.
            </p>
            <div className="cta-buttons">
              <a href="/#contact" className="btn btn-primary">Get Free Quote</a>
            </div>
            <div className="cta-assurance">
              <span>✓ Fully insured</span>
              <span>✓ Satisfaction guaranteed</span>
              <span>✓ Free quotes</span>
              <span>✓ No hidden fees</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PatioCleaningPage;